import { ApplicationStatus, Verification } from "shared/types";
import { Applicant } from "types/application";
import { PendingReportView } from "./PendingReportView";
import { PetScreeningReportSlice } from "../../slices/PetScreeningReportSlice";

interface PetScreeningReportViewProps {
  verification: Verification;
  applicant: Applicant;
  applicationStatus: ApplicationStatus;
}

export const PetScreeningReportView = ({
  verification,
  applicant,
  applicationStatus
}: PetScreeningReportViewProps) => {
  if (!verification.requested_at)
    return (
      <div className="h-full mx-auto">
        <PendingReportView />
      </div>
    );

  return (
    <PetScreeningReportSlice
      applicationStatus={applicationStatus}
      verification={verification}
      applicant={applicant}
    />
  );
};
